import { Box, Flex, Text } from '@chakra-ui/react';
import * as React from 'react';

import type { PointOfView } from './message-preview';

export interface MessageOutgoingProps {
  id: string;
  message: React.ReactNode;
  pointOfView?: PointOfView;
  systemPrefix?: string;
  orgPrefix?: string;
  titlePrefix?: string;
  namePrefix?: string;
  caseIdPrefix?: string;
  phonePrefix?: string;
  separator?: string;
}

export const MessageOutgoing: React.FC<MessageOutgoingProps> = ({
  id,
  message,
  pointOfView = 'contact',
  systemPrefix,
  orgPrefix,
  titlePrefix,
  namePrefix,
  caseIdPrefix,
  phonePrefix,
  separator = ' | ',
}) => {
  const isContactView = pointOfView === 'contact';

  const standardPrefixes = [
    systemPrefix,
    namePrefix,
    titlePrefix,
    caseIdPrefix,
  ].filter(Boolean);

  return (
    <Flex key={id} justifyContent="flex-start" mb={3}>
      <Box
        bg={isContactView ? 'bg.surface.lv0' : 'navy.solid'}
        color={isContactView ? 'fg' : 'navy.contrast'}
        p={3}
        borderRadius="md"
        maxW="85%"
      >
        <Text fontSize="sm" whiteSpace="pre-wrap">
          {standardPrefixes.map((prefix) => `${prefix}${separator}`).join('')}
          {phonePrefix && (
            <Text as="span" color="blue.solid" textDecoration="underline">
              {phonePrefix}
            </Text>
          )}
          {phonePrefix && separator}
          {orgPrefix && `${orgPrefix}: `}
          {message}
        </Text>
      </Box>
    </Flex>
  );
};

export default MessageOutgoing;
